import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { Modal, Badge, Table, Space, Tabs } from 'antd'

import { Flex, FlexColumn, CardContainer, LightContainer } from '../Reusable/Container'
import PageHeader from '../Reusable/PageHeader'
import { LabeledInput } from '../Reusable/Input'
import { Button, TextButton } from '../Reusable/Button'
import HiddenInfo from '../Reusable/HiddenInfo'
import ViewBill from '../Pay/Bills/ViewBill'
import PDFDocument from '../Reusable/PDFDocument';
import { Image } from '../Reusable/Image'
import { ErrorAlert } from '../Reusable/Alert'
import { Text, Tag } from '../Reusable/Text'
import environment from '../../environment'
import moment from 'moment'
import { addressObjectToStr, toCurrency, getResourcePerm, renderBankIcon, addressObjectToMultiLineStr, getBPAccountsWithAccess, getDateInLocalTZ } from '../../Utils/util'
import { apiPOSTReq, getPreSignedS3Url } from '../../Utils/api'
import ModalClose from '../../Images/modal-close.png'
import ChevronDown from "../../Images/chevron-down.svg"
import ChevronUp from "../../Images/chevron-up.png"
import TableView from '../Reusable/TableView'
import ApprovalDetail from '../Reusable/ApprovalDetail'

const { TabPane } = Tabs

class Index extends Component {

    constructor(props) {
        super(props)

        const paymentsPerm = getResourcePerm("BusinessBanking.Payments")
        const recipientsPerm = getResourcePerm("BusinessBanking.Recipients")

        this.state = {
            name: 'New Approval Setting',
            amount: 2000,
            paymentType: "ACH",
            rule: "greater than",
            approvers: {
                0: [],
                1: [],
                2: []
            },
            approvalSettings: [],
            approvalBy: "Any",
            stepCount: 1,
            showEditSettingModal: false,
            levelTypes: {
                0: "ANY",
                1: "ANY",
                2: "ANY"
            },
            registeredUsers: [],
            selectedTab: "todo",
            loading: true,
            pageSize: 10,
            page: 0,
            payPage: 0,
            todoApprovals: [],
            todoPayApprovals: [],
            tab: (paymentsPerm.approve || recipientsPerm.approve) ? 'Banking' : 'Bill Payments',
            coaPagination: {
                current: 1,
                pageSize: 200
            },
            bankingNotificationCount: 0,
            billsNotificationCount: 0
        }
    }

    componentDidMount() {

        const urlStr = this.props.location.search.replace('?', '')
        const ref = (new URLSearchParams(urlStr).get('billpay') || '')

        if(ref === 'true'){
            this.setState({ tab: 'Bill Payments' })
        }

        this.fetchInbox()
        this.fetchPayablesInbox()
        this.getInboxCount({ initialLoad: true })
        this.getPayablesInboxCount({ initialLoad: true })
    }

    fetchInbox = (loadMore) => {
        const { UserInfo } = this.props.store
        const { pageSize, page, todoApprovals } = this.state

        const body = { "approverUserId": UserInfo.Email, "sortDirection": "DESC", size: pageSize, page: page }

        // console.log("pending approvals bb/getInboxItems body", body)

        this.setState({ loading: true })
        apiPOSTReq(`${environment.bbBaseUrl}/bb/approvals/getInboxItems`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp

                if (data.result) {
                    if (err) throw new Error(err)
                    this.setState({ todoApprovals: loadMore === true ? todoApprovals.concat(data.pendingItemList) : data.pendingItemList, loading: false, moreToLoad: data.pageable })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            }
        })
    }

    fetchPayablesInbox = (loadMore) => {
        const { UserInfo } = this.props.store
        const { pageSize, payPage, todoPayApprovals } = this.state

        const body = { "approverUserId": UserInfo.Email, "sortDirection": "DESC", size: pageSize, page: payPage }

        this.setState({ loadingPay: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/approvals/getInboxItems`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp

                if (data.result) {
                    if (err) throw new Error(err)
                    this.setState({ todoPayApprovals: loadMore === true ? todoPayApprovals.concat(data.pendingItemList) : data.pendingItemList, loadingPay: false, morePayToLoad: data.pageable })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            }
        })
    }

    getInboxCount = (options) => {
        var { initialLoad } = options || {}
        const { tab } = this.state
        const { UserInfo } = this.props.store
        var username = UserInfo.Email
        apiPOSTReq(`${environment.bbBaseUrl}/bb/approvals/getInboxItems`, { "BankProvider": environment.bankProvider.crb }, { "approverUserId": username }, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)
                    if (data.count > 0) {
                        this.setState({ bankingNotificationCount: data.count })
                    }
                    else this.setState({ bankingNotificationCount: null })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERROR bb/approvals/getInboxItems", error, err, resp)
            }
        })
    }

    getPayablesInboxCount = (options) => {
        var { initialLoad } = options || {}
        const { bankingNotificationCount, tab } = this.state
        const { UserInfo } = this.props.store
        var username = UserInfo.Email
        apiPOSTReq(`${environment.payBaseUrl}/payables/approvals/getInboxItems`, { "BankProvider": environment.bankProvider.crb }, { "approverUserId": username }, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)
                    if (data.count > 0) {
                        this.setState({ billsNotificationCount: data.count })
                    }
                    else this.setState({ billsNotificationCount: null })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERROR payables/approvals/getInboxItems", error, err, resp)
            }
        })
    }

    onTabChange = tab => {
        console.log("Approvals /payables/getInboxItems", tab)
        this.setState({ tab })
    }

    render() {
        const { moreToLoad, morePayToLoad, selectedApproval, page, payPage, loading, bill,
            tab, todoApprovals, todoPayApprovals, showApprovalModal, bankingNotificationCount, billsNotificationCount, transferMethod, billUrl, approvalRecord } = this.state
        const { theme } = this.props

        const paymentsPerm = getResourcePerm("BusinessBanking.Payments")
        const recipientsPerm = getResourcePerm("BusinessBanking.Recipients")
        const billPaymentsPerm = getResourcePerm("Payables.Bill Payments")
        const contractorPaymentsPerm = getResourcePerm("Payables.Contractor Payments")

        const todoColumns = [
            {
                title: 'Date',
                dataIndex: 'assignedTime',
                key: 'assignedTime',
                render: date => {
                    return <Text noWrap>{moment(date).format('MMM Do, YYYY')}</Text>
                },
            },
            {
                title: 'Description',
                dataIndex: 'contextIdentifier',
                key: 'contextIdentifier',
                render: (contextIdentifier, item) => {
                    var tag = item.objectType

                    if (item.objectType === "Counterparty") tag = "New Recipient"
                    if (item.objectType === "BillPay") tag = "Check"
                    if (item.objectType === "InstantXfer") tag = "Instant"
                    return (
                        <Space><b>{contextIdentifier}</b><Tag tagpreset={theme.colors.secondary4}>{tag}</Tag></Space>
                    )
                },
            },
            {
                title: 'Requested By',
                dataIndex: 'initiatedBy',
                key: 'initiatedBy'
            },
            {
                key: 'action',
                render: (text, record) => {
                    return (
                        <TextButton style={{ padding: 0 }} onClick={() => {
                            this.setState({ billUrl: null, approvalRecord: record, showApprovalModal: true })
                        }} text='Review' />
                    )
                },
            }
        ]

        return (
            <>
                <FlexColumn className='main-padding'>
                    <PageHeader
                        subtitle="Approvals"
                        titleText="Approvals"
                        desc="Approve or reject any pending items"
                    />
                    {
                        ((paymentsPerm.approve || recipientsPerm.approve) && (billPaymentsPerm.approve || contractorPaymentsPerm.approve)) ?
                            <>
                                <Tabs size="large" onChange={this.onTabChange} activeKey={tab}>
                                    <TabPane
                                        tab={<Flex start centerHorizontally gap='8px'>
                                            <Text primary weight={tab === 'Banking' ? '500px' : '400px'}>Banking</Text>
                                            {
                                                (bankingNotificationCount || 0) > 0 &&
                                                <Badge style={{ backgroundColor: this.props.theme.colors.primary }} count={bankingNotificationCount} />
                                            }
                                        </Flex>}
                                        key="Banking"
                                    >
                                        <TableView
                                            id="pending-table"
                                            key="pending-table"
                                            // className='borderless-table'
                                            titleText='Pending'
                                            tableLayout='auto'
                                            columns={todoColumns}
                                            dataSource={todoApprovals || []}
                                            rowKey='inboxId'
                                            loading={loading}
                                            pagination={false}
                                            onChange={(pagination, filters, sorter) => {
                                                this.setState({ inboxPagination: pagination })
                                            }}
                                        />
                                    </TabPane>
                                    <TabPane
                                        tab={<Flex start centerHorizontally gap='8px'>
                                            <Text primary weight={tab === 'Bill Payments' ? '500px' : '400px'}>Bill Payments</Text>
                                            {
                                                (billsNotificationCount || 0) > 0 &&
                                                <Badge style={{ backgroundColor: this.props.theme.colors.primary }} count={billsNotificationCount} />
                                            }
                                        </Flex>}
                                        key="Bill Payments"
                                    >
                                        <TableView
                                            id="todo-pay-table"
                                            key="todo-pay-table"
                                            className='borderless-table'
                                            titleText='Pending'
                                            tableLayout='auto'
                                            columns={todoColumns}
                                            dataSource={todoPayApprovals || []}
                                            rowKey='inboxId'
                                            loading={loading}
                                            pagination={false}
                                            onChange={(pagination, filters, sorter) => {
                                                this.setState({ inboxPagination: pagination })
                                            }}
                                        />
                                    </TabPane>
                                </Tabs>
                            </>
                            :
                            <TableView
                                id="todo-table"
                                key="todo-table"
                                className='borderless-table'
                                tableLayout='auto'
                                columns={todoColumns}
                                dataSource={(paymentsPerm.approve || recipientsPerm.approve) ? todoApprovals : todoPayApprovals}
                                rowKey='objectId'
                                style={{ marginTop: 12 }}
                                loading={loading}
                                onChange={(pagination, filters, sorter) => {
                                    this.setState({ inboxPagination: pagination })
                                }}
                            />
                    }

                    {
                        ((tab === 'Bill Payments' && morePayToLoad === true) || (tab === 'Banking' && moreToLoad === true)) &&
                        <Flex style={{ marginTop: 24 }} fullWidth centerVertically><TextButton text='LOAD 10 MORE' loading={loading} onClick={() => {
                            if (tab === 'Bill Payments') {
                                this.setState({ payPage: payPage + 1 }, () => this.fetchPayablesInbox(true))
                            } else {
                                this.setState({ page: page + 1 }, () => this.fetchInbox(true))
                            }
                        }} rightIcon={<img style={{ cursor: 'pointer' }} width='24px' height='24px' src={ChevronDown} />} /></Flex>
                    }
                </FlexColumn>

                <Modal
                    visible={showApprovalModal}
                    footer={null}
                    closable={true}
                    width={(tab === 'Bill Payments') ? 1250 : 700}
                    destroyOnClose={true}
                    onCancel={() => {
                        this.setState({ showApprovalModal: false })
                    }}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <ApprovalDetail 
                        selectedApproval={approvalRecord}
                        onSubmit={() => {                                
                            this.setState({ showApprovalModal: false })
                            this.fetchPayablesInbox()
                            this.fetchInbox()
                            this.getInboxCount()
                            this.getPayablesInboxCount()
                        }}
                        onApprovalAction={() => this.props.onApprovalAction ? this.props.onApprovalAction() : {}}
                        type={tab}
                    />
                </Modal >
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))